import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import Detector from 'three/examples/js/Detector.js'


const state = {
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  isSafari: /Safari/.test(navigator.userAgent),
  isWechat: /micromessenger/i.test(navigator.userAgent),
  isIOS: /(iOS|iPod|iPad|iPhone)/i.test(navigator.userAgent),
  isMobile: /(iPhone|iPad|iPod|Android)/i.test(navigator.userAgent),
  isWebGl: Detector.webgl,
  country: null,
  isChina: true,
  audio: {
    playable: false,
    bufferable: false
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}





// WEBPACK FOOTER //
// ./src/store/browser/index.js